import { render, staticRenderFns } from "./ProductFamilyEdit.vue?vue&type=template&id=b946b66a&scoped=true&"
import script from "./ProductFamilyEdit.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyEdit.vue?vue&type=style&index=0&id=b946b66a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946b66a",
  null
  
)

export default component.exports